import { render, staticRenderFns } from "./CodeCommentsComponent.vue?vue&type=template&id=01d4a4f7&scoped=true"
import script from "./CodeCommentsComponent.vue?vue&type=script&lang=js"
export * from "./CodeCommentsComponent.vue?vue&type=script&lang=js"
import style0 from "./CodeCommentsComponent.vue?vue&type=style&index=0&id=01d4a4f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d4a4f7",
  null
  
)

export default component.exports